<template>
  <v-card class="search-sor">
    <v-card-title class="justify-center pb-0">
      <v-spacer></v-spacer>
      <v-btn icon
             @click="onClose">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="d-flex flex-column flex-grow-1 overflow-y-auto">
      <v-row class="flex-grow-0">
        <v-col cols="12">
          <v-text-field clearable
                        hide-details
                        label="Search"
                        prepend-inner-icon="mdi-magnify"
                        v-model="keyword"></v-text-field>
        </v-col>
      </v-row>
      <v-row class="flex-grow-0">
        <v-col cols="3">
          <v-select outlined
                    clearable
                    hide-details
                    label="Volume"
                    :items="volumeOptions"
                    v-model="selectedVolumeId"></v-select>
        </v-col>
        <v-col cols="3">
          <v-select outlined
                    clearable
                    hide-details
                    label="Section"
                    :items="sectionOptions"
                    v-model="selectedSectionId"></v-select>
        </v-col>
        <v-col cols="3">
          <v-select outlined
                    clearable
                    hide-details
                    label="Rates Range"
                    :items="rateRangeOptions"
                    v-model="selectedRateRange"></v-select>
        </v-col>
        <v-col cols="3">
          <v-select outlined
                    clearable
                    hide-details
                    label="Work Nature"
                    :items="workNatureOptions"
                    v-model="selectedWorkNature"></v-select>
        </v-col>
      </v-row>
      <v-row class="flex-grow-0">
        <v-col cols="3">
          <v-select outlined
                    clearable
                    hide-details
                    label="Unit"
                    :items="unitIdOptions"
                    v-model="selectedUnitId"></v-select>
        </v-col>
        <v-col cols="3">
          <v-select outlined
                    clearable
                    hide-details
                    label="Proprietary / Approved Items"
                    :items="proprietaryOptions"
                    v-model="selectedProprietary"></v-select>
        </v-col>
        <v-col cols="3">
          <v-select outlined
                    clearable
                    hide-details
                    label="Specifically Order Items"
                    :items="specificallyOrderOptions"
                    v-model="selectedSpecificallyOrder"></v-select>
        </v-col>
<!--        <v-col cols="3">-->
<!--          <v-select outlined-->
<!--                    clearable-->
<!--                    hide-details-->
<!--                    label="Extra Over"-->
<!--                    :items="extraOverOptions"-->
<!--                    v-model="selectedExtraOver"></v-select>-->
<!--        </v-col>-->
        <v-col cols="3">
          <v-select outlined
                    clearable
                    hide-details
                    label="Extra Over / Add To"
                    :items="addToOptions"
                    v-model="selectedAddTo"></v-select>
        </v-col>
      </v-row>
<!--      <v-row class="flex-grow-0">-->
<!--        <v-col cols="3">-->
<!--          <v-select outlined-->
<!--                    clearable-->
<!--                    hide-details-->
<!--                    label="Add To"-->
<!--                    :items="addToOptions"-->
<!--                    v-model="selectedAddTo"></v-select>-->
<!--        </v-col>-->
<!--      </v-row>-->
      <v-row class="flex-grow-0">
        <v-col>
          <v-btn class="mr-4"
                 @click="clearFilters">Clear
          </v-btn>
          <v-btn class="mr-4"
                 color="primary"
                 @click="search">Search
          </v-btn>
          <v-btn class="mr-4"
                 color="primary"
                 @click="visualise">Data Visualisation
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="flex-grow-0">
        <v-col>
          <v-divider></v-divider>
        </v-col>
      </v-row>
      <v-row v-if="showSearchList"
             class="flex-grow-1">
        <ItemSearchList full-height
                        @add="$emit('submit', $event)"
                        :work-order="workOrder"
                        :sor-id="workOrder? workOrder.contract.finalised_sor : sorId"
                        :sor-name="sorName"
                        :extra-params="searchParams"
                        :extra-filters="searchFilter"></ItemSearchList>
      </v-row>
      <SorItemVisualisation :visualise-results="visualiseResults"
                            v-if="showVisualisation"></SorItemVisualisation>
    </v-card-text>
  </v-card>
</template>

<script>
import {computed, onMounted, ref} from "@vue/composition-api";
import {ACTION_TYPES} from "@/store/types";
import ItemSearchList from "@/components/sor/ItemSearchList";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {Bar, Doughnut, Line, Pie, Radar} from 'vue-chartjs/legacy'
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  RadialLinearScale,
  Title,
  Tooltip,
} from 'chart.js'
import _ from "lodash";
import SorItemVisualisation from "@/components/sor/SorItemVisualisation";
import {WORK_NATURE} from "@/constants";

ChartJS.register(ChartDataLabels, ArcElement, Title, Tooltip, Legend, BarElement, CategoryScale, RadialLinearScale, LinearScale, PointElement, LineElement)
export default {
  name: 'SearchSorDialog',
  components: {SorItemVisualisation, ItemSearchList, Pie, Doughnut, Radar, Bar, LineChart: Line},
  props: {
    workOrder: Object,
    sorId: String,
    sorName: String,
    showAdd: Boolean,
  },
  setup(props, {root, emit}) {
    const onClose = function () {
      // if (confirm('Confirm Closing Window?')) {
        root.$emit('submit', undefined);
      // }
    }

    const keyword = ref(null);

    const volumes = ref([]);
    const volumeOptions = computed(() => {
      return volumes.value.map((v) => {
        return {text: v.name, value: v.id};
      })
    });
    const selectedVolumeId = ref(null);

    const sections = ref([]);
    const sectionOptions = computed(() => {
      let filtered = sections.value;
      if (selectedVolumeId.value) {
        filtered = _.filter(filtered, (s) => {
          return s.volume.id === selectedVolumeId.value;
        });
      }

      return filtered.map((s) => {
        return {text: `${s.order_no}. ${s.name}`, value: s.id};
      })
    });
    const selectedSectionId = ref(null);

    // const extraOverOptions = ref([
    //   {text: 'YES', value: [WORK_NATURE.EXTRA_OVER]},
    //   {text: 'NO', value: [
    //       WORK_NATURE.FIX_ONLY,
    //       WORK_NATURE.SUPPLY_ONLY,
    //       WORK_NATURE.SUPPLY_AND_FIX_AND_MISC,
    //       WORK_NATURE.TD_AND_CLEAR_WAY,
    //       WORK_NATURE.TD_AND_SET_ASIDE_FOR_REUSE,
    //     ]},
    // ]);
    // const selectedExtraOver = ref(null);

    const addToOptions = ref([
      {text: 'YES', value: true},
      {text: 'NO', value: false},
    ])
    const selectedAddTo = ref(null);

    const proprietaryOptions = ref([
      {text: 'YES', value: true},
      {text: 'NO', value: false},
    ]);
    const selectedProprietary = ref(null);

    const rateRangeOptions = ref([
      {text: '< $20', value: 'A'},
      {text: '$21 - $50', value: 'B'},
      {text: '$51 - $200', value: 'C'},
      {text: '$201 - $500', value: 'D'},
      {text: '$501 - $3000', value: 'E'},
      {text: '$3001 - $10000', value: 'F'},
      {text: '$10001 - $100000', value: 'G'},
      {text: '> $100000', value: 'H'},
    ]);
    const selectedRateRange = ref(null);

    const workNatureOptions = ref([
      {text: 'FIX ONLY', value: 'FIX_ONLY'},
      {text: 'SUPPLY ONLY', value: 'SUPPLY_ONLY'},
      {text: 'SUPPLY AND FIX / MISC.', value: 'SUPPLY_AND_FIX_AND_MISC'},
      {text: 'TD & CLEAR AWAY', value: 'TD_AND_CLEAR_WAY'},
      {text: 'TD & SET ASIDE FOR RE-USE', value: 'TD_AND_SET_ASIDE_FOR_REUSE'},
      // {text: 'EXTRA OVER', value: 'EXTRA_OVER'},
    ]);
    const selectedWorkNature = ref(null);

    const unitIdOptions = ref([
      {text: 'Cubic Meter', value: 'A'},
      {text: 'Square Meter', value: 'B'},
      {text: 'Linear Meter', value: 'C'},
      {text: 'Kilogram', value: 'D'},
      {text: 'Per item / no. / set', value: 'E'},
    ]);
    const selectedUnitId = ref(null);

    const specificallyOrderOptions = ref([
      {text: 'YES', value: true},
      {text: 'NO', value: false},
    ]);
    const selectedSpecificallyOrder = ref(null);

    const clearFilters = function () {
      selectedVolumeId.value = null;
      selectedSectionId.value = null;
      // selectedExtraOver.value = null;
      selectedProprietary.value = null;
      selectedRateRange.value = null;
      selectedWorkNature.value = null;
      selectedUnitId.value = null;
      selectedSpecificallyOrder.value = null;
    }

    const showSearchList = ref(false);
    const currentSearchFilter = computed(() => {
      const filter = {};

      if (keyword.value) {
        filter['search_string'] = {search: true, value: keyword.value.split(" ")};
      }

      if (selectedVolumeId.value) {
        filter['item_group.section.volume.id'] = selectedVolumeId.value;
      }

      if (selectedSectionId.value) {
        filter['item_group.section.id'] = selectedSectionId.value;
      }

      // if (selectedExtraOver.value !== null) {
      //   filter['work_nature'] = selectedExtraOver.value;
      // }

      if (selectedAddTo.value !== null) {
        filter['item_group.is_add_to'] = {exact: true, value: selectedAddTo.value};
      }

      if (selectedProprietary.value !== null) {
        filter['is_proprietary'] = {exact: true, value: selectedProprietary.value};
      }

      if (selectedRateRange.value) {
        filter['rate_range'] = {exact: true, value: selectedRateRange.value};
      }

      if (selectedWorkNature.value) {
        filter['work_nature'] = {exact: true, value: selectedWorkNature.value};
      }

      if (selectedUnitId.value) {
        filter['item_group.sub_sub_section.unit_id'] = {exact: true, value: selectedUnitId.value};
      }

      if (selectedSpecificallyOrder.value !== null) {
        filter['is_specifically_order'] = {exact: true, value: selectedSpecificallyOrder.value};
      }

      return filter;
    })
    const searchParams = ref(null);
    const searchFilter = ref(null);
    const search = function () {
      searchParams.value = {'sort_by_relevancy': keyword.value};
      searchFilter.value = {
        "item_group.is_deleted": {exact: true, value: false},
        ...currentSearchFilter.value
      };
      showSearchList.value = true;
      showVisualisation.value = false;
    }


    const showVisualisation = ref(false);
    const visualiseResults = ref(null);
    const visualise = async function () {
      showSearchList.value = false;
      showVisualisation.value = true;
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/sor/stats/',
        params: {
          sor_id: props.workOrder ? props.workOrder.contract.finalised_sor : props.sorId,
          filters: {
            "item_group.is_deleted": {exact: true, value: false},
            ...currentSearchFilter.value
          },
        },
      });
      visualiseResults.value = response.body;
    }

    const getOptions = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/sor/search_options/',
        params: {sor_id: props.workOrder ? props.workOrder.contract.finalised_sor : props.sorId},
      });

      if (response.body.success) {
        sections.value = response.body.sections;
        volumes.value = response.body.volumes;
      }
    };

    onMounted(() => {
      getOptions();
    })

    return {
      onClose,
      keyword,
      volumeOptions,
      selectedVolumeId,
      sectionOptions,
      selectedSectionId,
      // extraOverOptions,
      // selectedExtraOver,
      addToOptions,
      selectedAddTo,
      proprietaryOptions,
      selectedProprietary,
      rateRangeOptions,
      selectedRateRange,
      workNatureOptions,
      selectedWorkNature,
      unitIdOptions,
      selectedUnitId,
      specificallyOrderOptions,
      selectedSpecificallyOrder,

      clearFilters,
      showSearchList,
      currentSearchFilter,
      searchFilter,
      searchParams,
      search,

      showVisualisation,
      visualise,
      visualiseResults,
    }
  },
}
</script>

<style lang="less">
.search-sor {
  display: flex;
  flex-direction: column;
  height: 90vh;

  .section-chart-div, .sub-section-chart-div, .proprietary-chart-div {
    padding-right: 8px;
    border-right: solid 1px #EEE;
  }
}
</style>
